import "slick-carousel/slick/slick.css";

import "slick-carousel/slick/slick-theme.css";

import React from "react";

import Slider from "react-slick";

function Offer() {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const slides = [
    {
      title: "Oczyszczanie zarośniętych działek z krzaków i samosiejek",
      desc: [
        "Działka zarośnięta krzakami – szybkie oczyszczenie terenu",
        "Uporządkowanie działki przed budową lub sprzedażą",
        "Oczyszczanie terenu nieużytkowanego od lat",
      ],
      img: "https://magazyn.drzewus.pl/wp-content/uploads/2025/02/czyszczenie-dzialek-Large.jpeg",
      link: "/prace-ziemne/czyszczenie-dzialek",
    },
    {
      title: "Mulczowanie działek i zarośli – szybka metoda oczyszczenia terenu",
      desc: [
        "Mulczowanie zarośli i małych drzew",
        "Mulczowanie działki budowlanej i inwestycyjnej",
        "Mulczowanie jako sposób na oczyszczenie działki",
      ],
      img: "https://magazyn.drzewus.pl/wp-content/uploads/2025/04/mulczowanie-1.jpeg",
      link: "/oczyszczanie-terenu/mulczer-lesny",
    },
    {
      title: "Karczowanie działki i usuwanie krzaków pod inwestycję",
      desc: [
        "Karczowanie krzaków i korzeni",
        "Przygotowanie działki pod budowę domu",
        "Oczyszczanie terenu pod ogrodzenie i drogi dojazdowe",
      ],
      img: "https://magazyn.drzewus.pl/wp-content/uploads/2025/04/wycinka-klasyczna-3.jpeg",
      link: "/oczyszczanie-terenu/karczowanie-drzew",
    },
    {
      title: "Wycinka drzew na działce i przygotowanie terenu pod budowę",
      desc: [
        "Wycinka drzew pod inwestycje budowlane",
        "Usuwanie drzew z działek prywatnych i firmowych",
        "Oczyszczenie terenu po wycince",
      ],
      img: "https://magazyn.drzewus.pl/wp-content/uploads/2025/04/wycinka-klasyczna-1.jpeg",
      link: "/oczyszczanie-terenu/wycinka-klasyczna",
    },
    {
      title: "Frezowanie pni i usuwanie korzeni z terenu",
      desc: [
        "Frezowanie pni po wycince drzew",
        "Usuwanie korzeni pod trawnik, kostkę i fundamenty",
        "Przygotowanie terenu po usunięciu pni",
      ],
      img: "https://magazyn.drzewus.pl/wp-content/uploads/2025/04/frezowanie-pni-1.jpeg",
      link: "/oczyszczanie-terenu/frezowanie-pni",
    },
    {
      title: "Przygotowanie działki pod sprzedaż, zakup lub inwestycję",
      desc: [
        "Szybkie uporządkowanie działki do sprzedaży",
        "Oczyszczenie działki przed zakupem",
        "Przygotowanie terenu dla dewelopera i firm budowlanych",
      ],
      img: "https://magazyn.drzewus.pl/wp-content/uploads/2024/11/przygotowanie-dokumentacji-Duzy.jpeg",
      link: "/oczyszczanie-terenu/przygotowanie-dokumentacji",
    },
    {
      title: "Zakładanie trawnika i ogrodu od podstaw",
      desc: [
        "Trawnik z rolki – szybkie zagospodarowanie terenu",
        "Trawnik z siewu – przygotowanie i wyrównanie terenu",
        "Przygotowanie terenu pod ogród i zieleń",
      ],
      img: "https://magazyn.drzewus.pl/wp-content/uploads/2025/02/zakladanie-ogrodow-Large.jpeg",
      link: "/zakladanie-ogrodu",
    },
  ];

  return (
    <>
      <section id="uslugi" className="flex flex-col">
        <div className="grid grid-cols-1 lg:grid-cols-2 bg-gray-100 lg:h-[50vh]">
          <div className="flex flex-col items-center justify-center lg:h-[50vh] overflow-hidden">
            <img
              className="brightness-[90%]"
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Nasze-uslugi-Ekipa-ktora-zadba-o-Twoj-teren-od-A-do-Z.jpeg"
              alt="Ekipa Drzewus - usługi ogrodnicze od A do Z"
            />
          </div>
          <div className="p-6 lg:px-12 lg:py-24 flex flex-col items-start justify-center gap-2">
            <h2 className="uppercase color-yellow text-xl">Nasze usługi</h2>
            <h3 className="text-3xl lg:text-5xl color-green text-left">
              Ekipa, która zadba <br></br>
              <span className="color-yellow">o Twój teren</span> od A do Z
            </h3>
          </div>
        </div>
        <div className="pb-6">
          <div className="slider-offer lg:-translate-y-20 pt-6 lg:pt-0">
            <Slider {...settings}>
              {slides.map((slide, index) => (
                <div key={index}>
                  <a
                    href={slide.link}
                    className="mx-6 bg-white rounded-xl flex flex-col items-center justify-start gap-1 text-center p-6 hover:bg-gray-100 transition duration-300 ease-linear border border-[#f9f9f9f]"
                  >
                    <div className="h-[300px] w-full overflow-hidden flex flex-col items-center justify-center relative mb-6">
                      <img
                        className="rounded-xl w-full h-full object-cover"
                        src={slide.img}
                        alt={slide.title}
                      />
                    </div>
                    <h2 className="color-green text-xl">{slide.title}</h2>
                    <h3>
                      {slide.desc.map((line, i) => (
                        <React.Fragment key={i}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </h3>
                    <p className="color-green">Dowiedz się więcej</p>
                  </a>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer;